import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { DatabaseProvider } from '../../providers/database/database';
import { Observable } from "rxjs/Observable";
import * as _ from 'lodash';
import { AngularFireFunctions } from '@angular/fire/functions';
import { Storage } from '@ionic/storage';
import { Subject } from 'rxjs';
import { AngularFirestore, AngularFirestoreCollection } from "@angular/fire/firestore";
import firebase, { firestore } from "firebase/app";
import moment from 'moment';
import { AuthProvider } from '../../providers/auth/auth';
import { UtilityProvider } from '../../providers/utility/utility';
import { PdfProvider } from '../../providers/pdf/pdf';
import { take } from 'rxjs/operators';
import Timestamp = firebase.firestore.Timestamp;

interface UserProperties {
  clinic_id ? : string;
  clinic_name ? : string;
  email ? : string;
  password ? : string;
  phone ? : string;
  name ? : string;
}

@IonicPage()
@Component({
  selector: 'page-admin-utility',
  templateUrl: 'admin-utility.html',
})

export class AdminUtilityPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  rxsCollection: AngularFirestoreCollection<any>;
  document_path: string = 'clinics/';
  document_id: string = 'EA9TDWfZgBVNfXhGXYzG'
  document_path_new: string = '';
  document_id_new: string = '';
  document: any;

  collection_path: string = '';
  collection_path_new: string = '';
  collection: any;

  public clinicList: Observable<any[]>;
  clinic: any;
  clinic_name: string;
  clinic_id: string;
  clinic_province: string;

  user: any = {};

  json: string;

  NoOfDays: number = 0;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    private database: DatabaseProvider, 
    private afFun: AngularFireFunctions, 
    private storage: Storage,
    private alertCtrl: AlertController,
    private afs: AngularFirestore,
    private auth: AuthProvider,
    private utility: UtilityProvider,
    private pdf: PdfProvider
    ) {

      this.auth.getCurrentUser().then(user => {
        this.clinic_name = user.clinic_name;
        this.clinic_id = user.clinic_id;
        this.clinic_province = user.clinic_province;
        // console.log(this.clinic_id, this.clinic_name, this.clinic_province);
        this.database.getClinic(this.clinic_id)
        .valueChanges()
        .takeUntil(this.ngUnsubscribe)
        .subscribe((clinic) => {
          if (clinic) {
            this.clinic = clinic;
          }
        });
      });

    this.clinicList = this.database
    .getClinics()
    .snapshotChanges()
    .takeUntil(this.ngUnsubscribe)
    .map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        data.id = a.payload.doc.id;
        return data;
      });
    });
  }

  ngOnDestroy() {
    console.log('Leave admin utility and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  clearOrders() {
    this.storage.remove('RetinaOrderBatch').then(() => {
      let alert = this.alertCtrl.create({
        title: "Orders Removed",
        subTitle: "The batch of orders has been cleared",
        buttons: ["OK"]
      });
      alert.present();
      alert.onDidDismiss(() => {})
    });
  }

  getDoc()  {
    console.log(this.document_path)
    this.database.getDoc(this.document_path, this.document_id)
    .valueChanges()
    .takeUntil(this.ngUnsubscribe)
    .subscribe((data) => {
      console.log(data);
      this.document = JSON.stringify(data);
    })
  }

  updateDoc() {
    this.database.updateDoc(this.document_path, this.document_id, JSON.parse(this.document))
  }

  setDoc()  {
    this.database.setDoc(this.document_path_new, this.document_id_new, JSON.parse(this.document))
  }

  setDocWithID() {
    this.database.setDocWithID(this.document_path_new, JSON.parse(this.document))
  }

  getCollection() {
    console.log(this.collection_path)
    this.database.getCollection(this.collection_path)
    .snapshotChanges()
    .subscribe((data) => {
      console.log(data);

      let cache: any;
      this.collection = JSON.stringify(data, function(key, value) {
        if (typeof value === 'object' && value !== null) {
            if (cache.indexOf(value) !== -1) {
                // Circular reference found, discard key
                return;
            }
            // Store value in our collection
            cache.push(value);
        }
  return value;
});
    })
  }

  get timestamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
  }

  createId() {
    return this.afs.createId();
  }

  addJson() {
    const json = JSON.parse(this.json);
    json.forEach(r => {
      r.dob = moment(r.dob).format('YYYY-MM-DD')
      const createdAt = this.timestamp;
      const updatedAt = createdAt;
      const patientId = this.afs.createId();
      const doc = { createdAt, updatedAt, ...r };
      console.log('patient added: ', r);
      this.afs.doc(`clinics/${this.clinic_id}/patients/${patientId}`).set(doc)
    })
  }

  // async savePatient(row) {
  //   return new Promise(async (resolve, reject) => {
  //   console.log('Start FS Write');
  //   await this.database
  //     .addPatient(this.clinic_id, row)
  //     .then(response => {
  //       console.log("Write OK to FS", response);
  //       resolve(true);
  //     })
  //     .catch(err => {
  //       console.log("Write Error to FS", err);
  //       reject(false);
  //     });
  //   });
  // }

  setCollection() {
    let parseJSON = JSON.parse(this.collection)

    _(parseJSON).forEach((item) => {
      let document = _.omit(item, ['id']);
      this.database.setDocWithID(this.collection_path_new, document).then(_ => {
        console.log("Doc added: ", document);
      })
      .catch((err) => {
        console.log("Error adding document: ", document);
      })

    });

  }

  async createTestUser()  {
    console.log("Creating test user:", this.user)
      // Angular Fire - Converts Promise to Observable
    let testuser: UserProperties = {clinic_id: "3serdsdff3446", clinic_name: "Test Clinic", email: null, password: null, phone: null, name: null};
    testuser.email = this.user.email;
    testuser.password = this.user.password;
    testuser.phone = this.user.phone;
    testuser.name = this.user.name;

    console.log("Creating test user properties:", testuser);

    const respRef = await this.afFun.httpsCallable('addUser')(testuser).toPromise();
    console.log(respRef)
  }

  updateOrders()  {
    this.afs.collection('orders').snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        data.id = a.payload.doc.id;
        return data;
      });
    })
    .subscribe(items=>{
        items.forEach(order=>{
            this.afs.doc(`orders/${order.id}`).update({clinic_province:'ON'});
        })
     });
  }

  updateImagePath() {
    this.afs.collection<any>('prescriptions').snapshotChanges().map(actions => {
    return actions.map(async a => {
      const data = a.payload.doc.data();
      const id = a.payload.doc.id;

      // Firebase Reference
      // var storage = firebase.storage();

      // // Get the image storage reference
      // var imagePath = `gs://retina-47daf.appspot.com/${data.prescription_image.path}`;

      // //Create an image reference to the storage location
      // // var imagePathReference = storage.ref().child(imagePath);

      // // Get the download URL and set the local variable to the result (url)
      // // var newUrl = imagePathReference.getDownloadURL();

      // return { id, newUrl, ...data };

    });
  }).subscribe(items=>{
    items.forEach(rx=>{
      // let newUrl = await firebase.storage().ref(rx.prescription_image.path).getDownloadURL();
      console.log(rx);

        // this.afs.doc(`orders/${order.id}`).update({clinic_province:'ON'});
    })
 });
  }

  fixAlejandro()  {
    this.afs.collection("prescriptions", ref =>
      ref.where("clinic_id","==" ,this.clinic_id)).valueChanges()
    .subscribe(items=>{
      console.log("Alejandro Clinic Rx: ", items.length)
        items.forEach(rx=>{
            let newRxObject = {
              clinic_name: rx['clinic_name'].trim(),
              nursing_home: rx['nursing_home'].trim(),
              doctor: {
                first_name: rx['doctor']['first_name'].trim(),
                last_name: rx['doctor']['last_name'].trim(),
                license_number: rx['doctor']['license_number'].trim()
              }
            }
            console.log("New RX Object: ", newRxObject);
            this.afs.doc(`clinics/${this.clinic_id}/patients/${rx['patient_id']}/prescriptions/${rx['rx_id']}`).set(newRxObject, {merge: true});
        })
     });
  }

  createNewSummaryPDF()  {
    let order_number = 'ORD00190';
    let batch = [];
    let doctorSuppliesList = [];
    this.database.getPrescriptionBatchByClinicAndOrderNumber(this.clinic_id, order_number).valueChanges()
    .takeUntil(this.ngUnsubscribe)
    .subscribe(async rxarray => {
      console.log('rx: ', rxarray)
      let totalrx = rxarray;
      batch = rxarray;
      let type = 'Eylea PFS';
      let eylea_pfs_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Eylea vial';
      let eylea_vial_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Ozurdex';
      let ozurdex_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Avastin';
      let avastin_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Lucentis PFS';
      let lucentis_pfs_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Lucentis vial';
      let lucentis_vial_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Clindamycin PFS';
      let clindamycin_pfs_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Dexamethasone PFS';
      let dexamethasone_pfs_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Ocuflox';
      let ocuflox_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Beovu';
      let beovu_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      let total_count = eylea_pfs_count + eylea_vial_count + ozurdex_count + avastin_count + lucentis_pfs_count + lucentis_vial_count + clindamycin_pfs_count + dexamethasone_pfs_count + ocuflox_count + beovu_count;

      const doctors = batch.filter((doctor, i, arr) => arr.findIndex(t => t.doctor_id === doctor.doctor_id) === i).map(obj => obj.doctor);
      console.log('Doctors to get supplies for: ', doctors)
      doctorSuppliesList = [];
      const s = async () => {
        await this.utility.asyncForEach(doctors, async (doctor) => {
        // console.log(doc);
        this.database.getDefaultSuppliesByDoctor(doctor.id)
          .valueChanges()
          .takeUntil(this.ngUnsubscribe)
          .subscribe(supplies => {
            const newDocSupply = { doctor: {}, supplies: [] }
            newDocSupply.doctor = doctor;
            delete newDocSupply.doctor['signature'];
            newDocSupply.supplies = supplies;
            doctorSuppliesList.push(newDocSupply);
            console.log("Doc supply: ", doctor.last_name, newDocSupply);
          })
        });
      }
      s();
      console.log("Items: ", batch, doctorSuppliesList)


      let batchRx: any[] = [];
            
      const start = async () => {
        await this.utility.asyncForEach(doctors, async (doctor) => {     
          console.log("Write Rx Batch started");        
          batchRx.push(
            {
              order_batch: `${doctor.id}_${doctor.last_name}`,
              signature: doctor.signature,
              rx: batch.filter(rx => rx.doctor_id === doctor.id)
            }
          )
        });
      }
      start();
      console.log("Write Rx Batch finished");   
      let order = {};

      order['email'] = 'noreply@sentrex.com';
      order['clinic_id'] = this.clinic_id;
      order['clinic_name'] = this.clinic_name;
      order['clinic_province'] = this.clinic_province;
      order['Eylea_PFS'] = eylea_pfs_count;
      order['Eylea_vial'] = eylea_vial_count;
      order['Lucentis_PFS'] = lucentis_pfs_count;
      order['Lucentis_vial'] = lucentis_vial_count;
      order['Ozurdex'] = ozurdex_count;
      order['Avastin'] = avastin_count;
      order['Clindamycin_PFS'] = clindamycin_pfs_count;
      order['Dexamethasone_PFS'] = dexamethasone_pfs_count;
      order['Ocuflox'] = ocuflox_count;
      order['Beovu'] = beovu_count;
      order['Total'] = total_count;
      order['rx'] = batchRx;
      order['type'] = 'rx';
      order['note'] = '';

      console.log('Order: ', order)
      const filepath = await this.pdf.createOrderPDF(this.clinic, batchRx, '', [], doctorSuppliesList, null, order_number).catch(ex => {
        console.log("Exception creating pdf ", ex);
        return;
      })
      order['order_file'] = filepath;
      console.log("Got rx file", filepath);   
      console.log("before for each");
      const start2 = async () => {
        await order['rx'].forEach(async (batch) => {
          console.log('Post Order Creation Filter: ', batch.order_batch);
          const s3 = async () => {
            await batch.rx.forEach((rx) => {
              console.log('rx of batch pre: ', rx);
              rx.doctor.signature = null;
              console.log('rx of batch post: ', rx);
            })
          }
          s3();
        });
      }
      start2();

      console.log("after for each")
      console.log('Order: ', order)
      this.database.saveOrder(order, false).then((res) => {
        console.log("Save Order Result: ", res);
      })
    });
  }

  checkNursingHomes() {
    this.clinicList.subscribe(clinics => {
      clinics.forEach((clinic) => {
        console.log(clinic);
      })
    });
  }
    // const s3 = async () => {
    //   await this.clinicList.forEach((clinic) => {
    //     console.log(clinic)
    //     // if (clinic.locations.length > 0) {
    //     //   console.log('Clinic location: ', clinic.locations);
    //     // } else {
    //     //   console.log('One Primary Location: ', clinic.clinic_name);
    //     // }
    //   })
    // }
    // s3();

    archiveRx() {
      console.log("Archive Check for Rx Before: ", moment().subtract(this.NoOfDays, 'days').toDate().toISOString());
      const archived_date = this.database.timestamp;
      const twoMonthsAgo = Timestamp.fromDate(moment().subtract(this.NoOfDays, 'days').toDate());
      this.afs.collection("prescriptions", ref =>
      ref.where("filled_date", "<=", twoMonthsAgo))
      .snapshotChanges().map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .pipe(take(1))
      .subscribe(async (docs) => {
        console.log("Docs to archive: ", docs.length);
        let count = 1;
        const batches = _.chunk(docs, 100).map(docs => {
          console.log("Batch: ", count);
          const batch = this.afs.firestore.batch();
          docs.forEach(doc => {
              batch.set(this.afs.firestore.doc(`/prescriptions_archive/${doc.id}`),{...doc, archived_by: 'system', archived_date: archived_date});
              batch.delete(this.afs.firestore.doc(`/prescriptions/${doc.id}`));
            });
          count++;
          return batch.commit()
        });
        console.log("Write started");
        await Promise.all(batches)
        console.log("Write complete");
        })
    }

    checkTobra()  {
      this.database.getPrescriptionByClinicTobra(this.clinic_id)
      .snapshotChanges().map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .pipe(take(1))
      .subscribe(async (patients) => {

        let count = 1;
        let countoftobrapatients = patients.filter(p => p.tobra !== null).length;
        console.log("Patients to check tobra: ", patients.length, countoftobrapatients);
        const batches = _.chunk(patients.filter(p => p.tobra === 'Tobramycin 1-2 GTTS AE Q4H x 3D POST INJ'), 100).map(patients => {
          console.log("Batch: ", count, 100, patients.length);
          const batch = this.afs.firestore.batch();
          patients.forEach(rx => {
              if (rx.tobra === 'Tobramycin 1-2 GTTS AE Q4H x 3D POST INJ')  {
                batch.set(this.afs.firestore.doc(`clinics/${rx.clinic_id}/patients/${rx.patient.id}`),{ k_update: true, last_rx: {tobra: rx.tobra}}, { merge: true });
                console.log(rx.patient.last_name, rx.tobra);
              }
              // 
              // batch.delete(this.afs.firestore.doc(`/prescriptions/${doc.id}`));
            });
          count++;
          return batch.commit()
        });
        console.log("Write started", batches.length);
        await Promise.all(batches)
        console.log("Write complete");
      });
    }


    checkPatientPrescriptionNode()  {
      this.database.getPrescriptionsByClinic(this.clinic_id)
      .snapshotChanges().map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .pipe(take(1))
      .subscribe(async (rxs) => {

        let count = 1;
        let countrxs = rxs.length;
        console.log("Rxs to check: ", countrxs);
        const batches = _.chunk(rxs, 100).map(r => {
          console.log("Batch: ", count, r.length);
          const batch = this.afs.firestore.batch();
          r.forEach((rx, idx) => {
            rx.tobra = rx.tobra ? rx.tobra : null;
            delete rx.updateAt;
            if (idx === 0)  {
              console.log(`Batch ${count} - Item 1: `, { k_update: true, ...rx });
            }
            batch.set(this.afs.firestore.doc(`clinics/${rx.clinic_id}/patients/${rx.patient.id}/prescriptions/${rx.id}`),{ k_update: true, ...rx }, { merge: true });
          });
          count++;
          return batch.commit()
        });
        console.log("Write started", batches.length);
        await Promise.all(batches)
        console.log("Write complete");
      });
    }
}




// WEBPACK FOOTER //
// ./src/pages/admin-utility/admin-utility.ts